module.exports = __webpack_public_path__ + "img/big-data-icon.4b43d57d.png";